import React from 'react';
import './Select.scss';
export interface Props {
  selectClass?: any;
  selectId?: any;
  selectValue?: any;
  children?: any;
  onChange?: (event: any) => void;
  selectStyle?: React.CSSProperties;
}
const Select = ({
  selectClass,
  selectId,
  selectValue,
  children,
  onChange,
  selectStyle
}:Props) => {
  return (
    <select style={selectStyle && selectStyle} className={`mfg-select${selectClass?(' ' + selectClass) :''}`} id={selectId} value={selectValue} onChange={onChange}>
      {children}
    </select>
  )
}

export default Select